/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable */
import { MenuItem, TextField, FormControlLabel, Switch } from '@mui/material';
import { useState, useEffect, useCallback } from 'react';
// import DatePicker from 'rsuite/DatePicker';
import moment from 'moment';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
// eslint-disable-next-line no-unused-vars
import { CheckPicker, Input } from 'rsuite';

import IconInput from '../Forms/Inputs/IconInput';
import styles from './POGeneralDetails.module.scss';
import GSTInComp from './GSTInComp/GSTInComp';
import POVendorDetails from './VendorDetails/POVendorDetails';
import { notificationServices } from '../../Services';
import { Tabs, TabsList, TabsTrigger } from '../ui/tabs';
import { urls } from '@/Constants';
import { Button } from '../ui/button';
import CustomInputSelector from '../CustomInputSelector/CustomInputSelector';
import { classes } from '@/Helpers';
import DatePickerCustom from '../DatePickerCustom/DatePickerCustom';
import storeServices from '@/Services/Form Services/store.services';
import { ArrowRight } from 'lucide-react';

export const paymentTerms = [
	'Net 15',
	'Net 30',
	'Net 45',
	'Net 60',
	'Due end of the month',
	'Due end of next month',
	'Due on receipt',
];

function POGeneralDetails(props) {
	const {
		dispatchDelta,
		filteredStoresList,
		vendors,
		state,
		setState,
		toggleAddVendorModal,
		requiredFields,
		shiftsList,
		P2PTransfer,
		processList,
		isEdit,
		disableMsg,
		isDeliverToDisabled,
		orderType,
		filterLabels = {},

		mandatoryFields = {},
		thisStore = false,
		disbalePaymentTerm = false,
		uploadInvoiceCick,
		doc,
		// isEdit = false,
		queryUserOrderType,
		type,
		disableAll,
		processFromStoreList,
		internalPOTypes,
		externalStyles = {},
		canMakePackOrders = false,
		clientId,
	} = props;
	const {
		vendor: selectedVendor,
		vendorLocation: selectedVendorLocation,
		deliverTo,
		purchaseOrderId,
		date,
		expectedDeliveryDate,
		paymentTerm,
		fromStore,
		store,
		selectedProcess,
		toProcess,
		selectedShift,
		fromProcess,
		inventoryAtDayEndOf,
		transferOrderType,
		workOrderType,
		externalOrderRef,
		orderTypeInternal,
		internalProcess,
		internalShift,
		priorityOrder,
	} = state ?? {};
	const history = useHistory();
	const [allStores, setAllStores] = useState([]);
	const [formattedDate, setFormattedDate] = useState(null);

	const handleNumericInput = (e) => {
		const value = e?.target?.value;
		if (value.length > 25) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Purchase Order ID cannot be more than 25 digits',
			});
			return;
		}
		setState('SET_PURCHASE_ORDER', value);
	};

	const handleOrderRefInput = (value) => {
		if (value.length > 20) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Order Ref No cannot be more than 20 digits',
			});
			return;
		}
		setState('SET_EXTERNAL_ORDER_REF', value);
	};

	useEffect(() => {
		if (dispatchDelta) {
			const dispatchDate = new Date(expectedDeliveryDate);
			dispatchDate.setDate(
				expectedDeliveryDate.getDate() - dispatchDelta
			);
			const formatedDate = dispatchDate.toISOString().split('T')[0];
			setFormattedDate(formatedDate);
		}
	}, [expectedDeliveryDate, dispatchDelta]);

	useEffect(() => {
		if (isEdit) {
			const findSelectedVendorLocation =
				state?.vendor?.vendor_locations?.find((ele) => {
					return Number(ele?.id) === Number(state?.vendorLocationId);
				});
			setState('SET_VENDOR_LOCATION', findSelectedVendorLocation);
		}
	}, [isEdit, state?.vendor?.vendor_locations, state?.vendorLocationId]);

	const handleOrderTypeInternal = (value) => {
		setState('SET_ORDER_TYPE_INTERNAL', value);
		if (value === 'PO') {
			setState('SET_INTERNAL_PROCESS', null);
			setState('SET_INTERNAL_SHIFT', null);
		}
	};

	const handleInternalSelectProcess = (value) => {
		setState('SET_INTERNAL_PROCESS', value);
		setState('SET_INTERNAL_SHIFT', null);
	};

	const handleInternalSelectShift = (value) => {
		setState('SET_INTERNAL_SHIFT', value);
	};

	const fetchAllStores = async () => {
		const req = {
			id: '',
			type: 'BASE,WAREHOUSE_PRODUCT,WAREHOUSE,WAREHOUSE_INGREDIENT,RETAIL',
		};
		try {
			const response = await storeServices.getStore(req);
			if (response?.statusCode === 200) {
				setAllStores(response?.data);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	useEffect(() => {
		fetchAllStores();
	}, []);

	const selectVendorLocation = (currVendorLocation) => {
		setState('SET_VENDOR_LOCATION', currVendorLocation);
	};

	const handleFromStoreSelection = (store_) => {
		// if (orderType !== 3) {
		if (store_?.id && state?.deliverTo?.id) {
			if (store_?.id !== state?.deliverTo?.id) {
				setState('SET_FROM_STORE', store_);
			} else {
				notificationServices.generateNotification({
					type: 'warning',
					message: 'From and To Store cannot be same',
				});
			}
		} else {
			setState('SET_FROM_STORE', store_);
			setState('SET_INTERNAL_PROCESS', null);
			setState('SET_INTERNAL_SHIFT', null);
		}
		// } else {
		// setState('SET_FROM_STORE', store_);
		// }
	};

	const handleWorkersGradeChange = (ele, value) => {
		const updatedWorkersGrade = state?.workersGrade?.map((item) => {
			if (item?.label === ele?.label) {
				return { ...item, value: value };
			}
			return item;
		});
		setState('SET_WORKERS_GRADE', updatedWorkersGrade);
	};

	const handleAddVendor = () => {
		toggleAddVendorModal(true, {});
	};

	const handleDeliverToSelect = (deliverToStore) => {
		// if (orderType !== 3) {
		if (deliverToStore?.id && state?.fromStore?.id) {
			if (deliverToStore?.id !== state?.fromStore?.id) {
				setState('SET_DELIVER_TO', deliverToStore);
			} else {
				notificationServices.generateNotification({
					type: 'warning',
					message: 'From and To Store cannot be same',
				});
			}
		} else {
			setState('SET_DELIVER_TO', deliverToStore);
		}
		// } else {
		// setState('SET_DELIVER_TO', deliverToStore);
		// }
	};

	const handleSelectProcess = (currProcess) => {
		setState('SET_PROCESS', currProcess);
	};
	const handleStoreSelection = (store_) => {
		setState('SET_STORE', store_);
		setState('SET_FROM_PROCESS', null);
		setState('SET_TO_PROCESS', null);
	};
	const handleTransferOrderType = (value) => {
		setState('SET_TRANSFER_ORDER_TYPE', value);
	};
	const handleWorkOrderType = (value) => {
		setState('SET_WORK_ORDER_TYPE', value);
	};
	const handleSelectFromProcess = (currProcess) => {
		setState('SET_FROM_PROCESS', currProcess);
	};
	const handleSelectToProcess = (currProcess) => {
		setState('SET_TO_PROCESS', currProcess);
		setState('SET_SHIFT', null);
	};

	const handleSelectToShift = (currProcess) => {
		setState('SET_SHIFT', currProcess);
	};
	// const disabledDate = (rsuiteDate) => {
	// return rsuiteDate < new Date().setDate(new Date().getDate() - 1);
	// };
	const disabledExpiryDate = (rsuiteDate) => {
		const previousDate = new Date(date);
		previousDate.setDate(previousDate.getDate() - 1);

		return rsuiteDate < previousDate;
	};
	const disabledYesterday = (rsuiteDate) => {
		const currentDateAtMidnight = moment().startOf('day');
		return rsuiteDate < currentDateAtMidnight;
	};

	const handleKeyPress = (e) => {
		const key = e?.target?.name ?? '';
		if (e.keyCode === 8) {
			setState(`SET_${key}`, {});
			if (key === 'VENDOR') {
				setState('SET_VENDOR_LOCATION', {});
			}
		}
	};

	const handleVendorSelection = (vendor) => {
		// console.log(vendor, ' vv');
		setState('SET_VENDOR', vendor);
		if (vendor?.vendor_locations?.length) {
			if (vendor?.vendor_locations?.length === 1) {
				setState('SET_VENDOR_LOCATION', vendor?.vendor_locations?.[0]);
			} else if (isEdit === false) {
				setState('SET_VENDOR_LOCATION', {});
			}
		} else {
			setState('SET_VENDOR_LOCATION', {});
		}
	};

	const filterShifts = (ele) => {
		if (
			moment(date).isSame(moment(), 'day') &&
			moment(ele?.endDate).isSameOrAfter()
		) {
			const startDate = moment(ele?.startDate, 'YYYY-MM-DD');
			const endDate = moment(ele?.endDate, 'YYYY-MM-DD');
			const currentTime = moment().startOf('day');
			// console.log('endDateTime', endDateTime);
			if (ele?.process?.[0]?.endTime === '12:00 AM') return true;
			return (
				currentTime.isSameOrAfter(startDate) &&
				currentTime.isSameOrBefore(endDate)
			);
		}
		return true;
	};

	// const onLocationAddComplete = useCallback(() => {
	// 	// selectVendorLocation({});
	// 	const tempVendor = vendors?.find((ele) => {
	// 		return ele?.id === state?.vendor?.id;
	// 	});
	// 	handleVendorSelection(tempVendor);
	// }, [vendors]);

	// useEffect(onLocationAddComplete, [vendors]);

	const STORES_LIST = useCallback(
		(wantFilter) => {
			if (wantFilter) {
				return filteredStoresList?.map((ele) => {
					return {
						...ele,
						imageUrl: ele?.logo,
					};
				});
			}
			return allStores?.map((ele) => {
				return {
					...ele,
					imageUrl: ele?.logo,
				};
			});
		},
		[allStores, filteredStoresList]
	);

	return (
		<div
			className={styles.root}
			style={{
				position: 'relative',
				...(externalStyles && externalStyles),
			}}
		>
			{disableMsg && (
				<div className='w-full h-3/5 flex items-center justify-center scale-105 bg-opacity-50 cursor-not-allowed bg-white absolute z-10 top-0 left-0'>
					<p className='text-red-800 text-xl text-center font-bold rotate-12'>
						{disableMsg}
					</p>
				</div>
			)}
			{state?.rejectionReason && (
				<div className={styles.rejected}>
					<p>This PO was rejected</p>
					<p className={styles.reason}>
						(Reason:
						{state?.rejectionReason})
					</p>
				</div>
			)}
			{orderType !== 7 && (
				<>
					{(requiredFields?.vendor || type === 'BUYER') && (
						<div className={styles['label-container']}>
							<label
								className={styles.mandatory}
								htmlFor='vendorSelection'
							>
								{/* {type === 'BUYER' ? 'Buyer Name*' : 'Vendor Name*'} */}
								{type === 'BUYER'
									? 'Buyer Name*'
									: type === 'SERVICE'
									? 'service Provider'
									: 'Vendor Name*'}
							</label>
							<CustomInputSelector
								inputName='VENDOR'
								width='300px'
								inputLists={vendors
									?.filter((vendor) => {
										if (
											orderType === 4 ||
											type === 'SERVICE' ||
											orderType === 1
										) {
											return [
												'INDENT',
												'CAPEX',
												'EXPENSE',
											].includes(vendor.vendorType);
										}
										return true;
									})
									?.map((ele) => {
										return {
											...ele,
											imageUrl: ele?.logo,
										};
									})}
								// eslint-disable-next-line no-unused-vars
								handleRemove={(key) => {
									handleVendorSelection(null);
									selectVendorLocation({});
								}}
								handleKeyPress={handleKeyPress}
								handleSelection={handleVendorSelection}
								addNewText={
									type === 'BUYER'
										? 'Add New Buyer'
										: 'Add New Vendor'
								}
								placeholder={
									type === 'BUYER'
										? 'Select A Buyer'
										: 'Select A Vendor'
								}
								selectedValue={selectedVendor?.name}
								classname={styles['vendor-selector']}
								handleAddNew={handleAddVendor}
							/>
						</div>
					)}
					{requiredFields?.vendorLocation && (
						<div className={classes(styles['vendor-container'])}>
							<div className={styles['label-container']}>
								<label
									className={
										mandatoryFields?.vendorLocation
											? styles.mandatory
											: ''
									}
									htmlFor='vendorSelection'
								>
									Vendor location
									{mandatoryFields?.vendorLocation ? '*' : ''}
								</label>
								<CustomInputSelector
									inputName='VENDOR_LOCATION'
									width='300px'
									disabled={!state?.vendor?.id}
									inputLists={state?.vendor?.vendor_locations?.map(
										(ele) => {
											return {
												...ele,
												imageUrl: ele?.logo,
											};
										}
									)}
									// eslint-disable-next-line no-unused-vars
									handleRemove={(key) => {
										selectVendorLocation(null);
									}}
									handleKeyPress={handleKeyPress}
									handleSelection={selectVendorLocation}
									addNewText='Add New Vendor Location'
									placeholder='Select Vendor Location'
									selectedValue={state?.vendorLocation?.name}
									classname={styles['vendor-selector']}
									handleAddNew={() => {
										toggleAddVendorModal(true, {
											vendorData: state?.vendor,
											isEdit: true,
											onLocationAddComplete,
										});
									}}
								/>
							</div>
							{selectedVendor?.id &&
								selectedVendorLocation?.id && (
									<POVendorDetails
										toggleAddVendorModal={
											toggleAddVendorModal
										}
										vendorDetails={{
											...selectedVendorLocation,
											vendorType:
												selectedVendor?.vendorType,
										}}
									/>
								)}
						</div>
					)}
				</>
			)}
			{(requiredFields?.buyerLocation || type === 'BUYER') && (
				<div className={classes(styles['vendor-container'])}>
					<div className={styles['label-container']}>
						<label
							className={
								mandatoryFields?.vendorLocation
									? styles.mandatory
									: ''
							}
							htmlFor='vendorSelection'
						>
							Buyer location
							{mandatoryFields?.buyerLocation ? '*' : ''}
						</label>
						<CustomInputSelector
							inputName='VENDOR_LOCATION'
							width='300px'
							disabled={!state?.vendor?.id}
							inputLists={state?.vendor?.vendor_locations?.map(
								(ele) => {
									return {
										...ele,
										imageUrl: ele?.logo,
									};
								}
							)}
							// eslint-disable-next-line no-unused-vars
							handleRemove={(key) => {
								selectVendorLocation(null);
							}}
							handleKeyPress={handleKeyPress}
							handleSelection={selectVendorLocation}
							addNewText='Add New Buyer Location'
							placeholder='Select Buyer Location'
							selectedValue={state?.vendorLocation?.name}
							classname={styles['vendor-selector']}
							handleAddNew={() => {
								toggleAddVendorModal(true, {
									vendorData: state?.vendor,
									isEdit: true,
									onLocationAddComplete,
								});
							}}
						/>
					</div>
					{selectedVendor?.id && selectedVendorLocation?.id && (
						<POVendorDetails
							toggleAddVendorModal={toggleAddVendorModal}
							vendorDetails={{
								...selectedVendorLocation,
								vendorType: selectedVendor?.vendorType,
							}}
						/>
					)}
				</div>
			)}
			{requiredFields?.fromStore && (
				<div className={classes(styles['vendor-container'])}>
					<div className={styles['label-container']}>
						<label
							className={styles.mandatory}
							htmlFor='vendorSelection'
						>
							{orderType === 8
								? 'Sales From Store*'
								: 'Purchase From Store*'}
						</label>
						<CustomInputSelector
							inputName='FROM_STORE'
							width='300px'
							inputLists={
								[8].includes(orderType) ||
								['sales'].includes(queryUserOrderType)
									? STORES_LIST(true)
									: STORES_LIST(false)
							}
							// eslint-disable-next-line no-unused-vars
							handleRemove={(key) => {
								handleFromStoreSelection(null);
							}}
							handleKeyPress={handleKeyPress}
							handleSelection={handleFromStoreSelection}
							hideAddNew
							placeholder='Select From Store'
							selectedValue={fromStore?.name}
							classname={styles['vendor-selector']}
						/>
					</div>
				</div>
			)}
			{requiredFields?.store && (
				<div className={classes(styles['vendor-container'])}>
					<div className={styles['label-container']}>
						<label className={styles.mandatory} htmlFor='store'>
							Select Store*
						</label>
						<CustomInputSelector
							inputName='store'
							width='300px'
							inputLists={
								[5, 6].includes(orderType)
									? STORES_LIST(true)
									: STORES_LIST(false)
							}
							// eslint-disable-next-line no-unused-vars
							handleRemove={(key) => {
								handleStoreSelection(null);
							}}
							handleSelection={handleStoreSelection}
							hideAddNew
							placeholder='Select Store'
							selectedValue={store?.name}
							classname={styles['vendor-selector']}
						/>
					</div>
				</div>
			)}
			{(requiredFields?.deliverTo ||
				requiredFields?.filteredDeliverTo) && (
				<div className={classes(styles['label-container'])}>
					<label className={styles.mandatory} htmlFor='deliverTo'>
						{type === 'SERVICE'
							? 'SERVICE LOCATION'
							: filterLabels?.store ?? 'Deliver To*'}
					</label>
					<div className={styles['deliver-to']}>
						<CustomInputSelector
							inputName='DELIVER_TO'
							width='300px'
							inputLists={
								['sales'].includes(queryUserOrderType)
									? STORES_LIST(false)
									: STORES_LIST(true)
							}
							disabled={isDeliverToDisabled}
							// eslint-disable-next-line no-unused-vars
							handleRemove={(key) => {
								handleDeliverToSelect(null);
							}}
							handleKeyPress={handleKeyPress}
							handleSelection={handleDeliverToSelect}
							hideAddNew
							placeholder={
								thisStore ? 'Select store' : 'Select Deliver to'
							}
							selectedValue={deliverTo?.name}
							classname={styles['vendor-selector']}
						/>
						{deliverTo?.id && (
							<GSTInComp
								gstIn={deliverTo?.gstNumber}
								onClick={() => {
									history.push(
										`${urls.EXTENSION}${urls.STORES}/edit/${deliverTo?.id}`
									);
								}}
							/>
						)}
					</div>
				</div>
			)}
			{requiredFields?.transferOrderType && (
				<div className={classes(styles['label-container'])}>
					<label className={styles.mandatory} htmlFor='deliverTo'>
						{filterLabels?.store ?? 'Deliver To*'}
					</label>
					<Tabs
						value={transferOrderType}
						onValueChange={handleTransferOrderType}
					>
						<TabsList className=''>
							{['PROCURE', 'DISPATCH']?.map((ele) => {
								return (
									<TabsTrigger
										className='data-[state=active]:bg-uy-color'
										value={ele}
									>
										{ele}
									</TabsTrigger>
								);
							})}
						</TabsList>
					</Tabs>
				</div>
			)}
			{requiredFields?.workOrderType && (
				<div className={classes(styles['label-container'])}>
					<label className={styles.mandatory} htmlFor='deliverTo'>
						Order Type*
					</label>
					<Tabs
						value={workOrderType}
						onValueChange={handleWorkOrderType}
					>
						<TabsList className=''>
							{['PRODUCTION PLAN', 'CMS', 'PACKAGING']
								.filter((ele) => {
									return (
										canMakePackOrders || ele !== 'PACKAGING'
									);
								})
								?.map((ele) => {
									return (
										<TabsTrigger
											className='data-[state=active]:bg-uy-color'
											value={ele}
										>
											{ele}
										</TabsTrigger>
									);
								})}
						</TabsList>
					</Tabs>
				</div>
			)}
			{requiredFields?.orderTypeInternal && (
				<div className={classes(styles['label-container'])}>
					<label className={styles.mandatory} htmlFor='deliverTo'>
						Order Type*
					</label>
					<Tabs
						value={orderTypeInternal}
						onValueChange={handleOrderTypeInternal}
					>
						<TabsList className=''>
							{Array.isArray(internalPOTypes) &&
							internalPOTypes?.length > 0
								? internalPOTypes?.map((ele) => {
										return (
											<TabsTrigger
												className='data-[state=active]:bg-uy-color'
												value={ele}
											>
												{ele}
											</TabsTrigger>
										);
								  })
								: ['PO', 'CMS', 'CMS_INDENT']?.map((ele) => {
										return (
											<TabsTrigger
												className='data-[state=active]:bg-uy-color'
												value={ele}
											>
												{ele}
											</TabsTrigger>
										);
								  })}
						</TabsList>
					</Tabs>
				</div>
			)}
			{['CMS', 'CMS_INDENT'].includes(orderTypeInternal) &&
				orderType == 2 && (
					<div className='flex flex-col gap-2'>
						{state?.fromStore?.id &&
							Array.isArray(processFromStoreList) &&
							processFromStoreList.length === 0 && (
								<span className='text-orange-400 text-[12px]'>
									No Process is configured at{' '}
									{state?.fromStore?.name} for selection.
									Please add a process to this store.
								</span>
							)}
						<div className={classes(styles['label-container'])}>
							<label
								className={styles.mandatory}
								htmlFor='deliverTo'
							>
								Select Process*
							</label>
							<CustomInputSelector
								inputName='From Process'
								width='300px'
								disabled={
									!processFromStoreList?.length ||
									!state?.fromStore?.id
								}
								inputLists={processFromStoreList?.map((ele) => {
									return {
										...ele,
										name:
											ele?.data?.heading +
											' (Section: ' +
											ele?.data?.sectionName +
											')',
									};
								})}
								handleSelection={handleInternalSelectProcess}
								hideAddNew
								handleRemove={() => {
									handleInternalSelectProcess(null);
								}}
								placeholder='Select Process'
								classname={styles['vendor-selector']}
								selectedValue={internalProcess?.name}
							/>
						</div>
					</div>
				)}
			{orderTypeInternal === 'CMS' && orderType == 2 && (
				<div className='flex flex-col gap-2'>
					{internalProcess?.id &&
						Array.isArray(shiftsList) &&
						shiftsList.length === 0 && (
							<span className='text-orange-400 text-[12px]'>
								No Shift is configured at{' '}
								{internalProcess?.name} for selection. Please
								add a shift to this process.
							</span>
						)}
					<div className={classes(styles['label-container'])}>
						<label className={styles.mandatory} htmlFor='shift'>
							Available shifts*
						</label>
						<div
							style={{
								width: '300px',
							}}
						>
							<CustomInputSelector
								inputName='Shift list'
								width='300px'
								disabled={!internalProcess?.id}
								inputLists={shiftsList
									?.map((ele) => {
										return {
											...ele,
											name: ele?.shiftName,
										};
									})
									?.filter(filterShifts)}
								// eslint-disable-next-line no-unused-vars
								handleRemove={(key) => {
									handleInternalSelectShift(null);
								}}
								handleSelection={handleInternalSelectShift}
								hideAddNew
								placeholder='Select shift'
								selectedValue={internalShift?.name}
								classname={styles['vendor-selector']}
							/>
							{internalShift && (
								<div className={styles.shiftStartEnd}>
									{internalShift?.process?.[0]?.startTime} -{' '}
									{internalShift?.process?.[0]?.endTime}
								</div>
							)}
						</div>
					</div>
				</div>
			)}
			{requiredFields?.fromProcess &&
				(requiredFields?.toProcess || orderType === 6) && (
					<div className={styles['vertical-container']}>
						<>
							<div className={styles.note}>
								Note: Shifts listed on the basis of{' '}
								{orderType !== 6 && (
									<span>
										{state?.transferOrderType !== 'DISPATCH'
											? 'Transfer To Process'
											: 'Transfer From Process'}
									</span>
								)}
								{orderType === 6 && (
									<span>
										{workOrderType === 'PACKAGING'
											? 'Packaging'
											: 'Preparation'}{' '}
										Process
									</span>
								)}
								, and{' '}
								<span>
									(
									{orderType === 6
										? `${
												workOrderType === 'PACKAGING'
													? 'Packaging'
													: 'Preparation'
										  } Date`
										: 'Transfer Date'}
									)
								</span>
							</div>
							<div className={classes(styles['label-container'])}>
								<label
									className={
										mandatoryFields?.fromProcess ||
										orderType === 6
											? styles.mandatory
											: ''
									}
									htmlFor='fromProcess'
								>
									{orderType === 6
										? `${
												workOrderType === 'PACKAGING'
													? 'Packaging'
													: 'Preparation'
										  } Process`
										: 'Transfer From Process'}
									{orderType === 6 ||
									mandatoryFields?.fromProcess
										? '*'
										: ''}
								</label>
								<CustomInputSelector
									inputName='From Process'
									width='300px'
									disabled={
										!processList?.length ||
										!state?.store?.id
									}
									inputLists={processList
										?.filter((ele) => {
											if (P2PTransfer) {
												return true;
											}
											if (
												[
													'PRODUCTION PLAN',
													'CMS',
												].includes(workOrderType)
											) {
												return (
													ele?.data?.type ===
													'OPERATION'
												);
											}
											if (
												state?.transferOrderType ===
												'DISPATCH'
											) {
												return (
													ele?.data?.type !==
														'STORAGE' &&
													!ele?.data?.nodeStore
												);
											}
											return (
												ele?.data?.type === 'STORAGE'
											);
										})
										?.map((ele) => {
											return {
												...ele,
												imageUrl: ele?.logo,
												name: `${
													ele?.data?.heading
												} (Section: ${
													ele?.data?.sectionName ??
													'-'
												})`,
											};
										})}
									// eslint-disable-next-line no-unused-vars
									handleRemove={(key) => {
										handleSelectToProcess(null);
									}}
									handleSelection={handleSelectToProcess}
									hideAddNew
									placeholder='Select from process'
									selectedValue={toProcess?.name}
									classname={styles['vendor-selector']}
								/>
							</div>
							{orderType !== 6 && (
								<div
									style={{
										width: '100%',
										display: 'flex',
										justifyContent: 'center',
									}}
								>
									<ArrowDownwardIcon />
								</div>
							)}
						</>
						{orderType !== 6 && (
							<div className={classes(styles['label-container'])}>
								<label
									className={
										mandatoryFields?.toProcess
											? styles.mandatory
											: ''
									}
									htmlFor='toProcess'
								>
									Transfer To Process
									{mandatoryFields?.toProcess ? '*' : ''}
								</label>
								<CustomInputSelector
									inputName='To Process'
									width='300px'
									disabled={
										!processList?.length ||
										!state?.store?.id
									}
									inputLists={processList
										?.filter((ele) => {
											if (P2PTransfer) {
												return true;
											}
											if (
												state?.transferOrderType ===
												'DISPATCH'
											) {
												return (
													ele?.data?.type ===
													'STORAGE'
												);
											}
											return (
												ele?.data?.type !== 'STORAGE' &&
												!ele?.data?.nodeStore
											);
										})
										?.map((ele) => {
											return {
												...ele,
												imageUrl: ele?.logo,
												name: `${
													ele?.data?.heading
												} (Section: ${
													ele?.data?.sectionName ??
													'-'
												})`,
											};
										})}
									// eslint-disable-next-line no-unused-vars
									handleRemove={(key) => {
										handleSelectFromProcess(null);
									}}
									handleSelection={handleSelectFromProcess}
									hideAddNew
									placeholder='Select To Process'
									selectedValue={fromProcess?.name}
									classname={styles['vendor-selector']}
								/>
							</div>
						)}
						<div className={classes(styles['label-container'])}>
							<label
								className={styles.mandatory}
								htmlFor='deliveryDate'
							>
								{orderType === 6
									? `${
											workOrderType === 'PACKAGING'
												? 'Packaging'
												: 'Preparation'
									  } Date`
									: 'Transfer Date'}
								*
							</label>
							<DatePickerCustom
								selectedDate={date}
								selectDate={(thisDate) => {
									setState('SET_DATE', thisDate);
									handleSelectToShift(null);
								}}
								style={{
									width: 300,
								}}
								oneTap
								defaultValue={date}
								shouldDisableDate={disabledYesterday}
							/>
						</div>
						<div className={classes(styles['label-container'])}>
							<label className={styles.mandatory} htmlFor='shift'>
								Available shifts*
							</label>
							<div
								style={{
									width: '300px',
								}}
							>
								<CustomInputSelector
									inputName='Shift list'
									width='300px'
									disabled={!state?.toProcess?.id}
									inputLists={shiftsList
										?.map((ele) => {
											return {
												...ele,
												name: ele?.shiftName,
											};
										})
										?.filter(filterShifts)}
									// eslint-disable-next-line no-unused-vars
									handleRemove={(key) => {
										handleSelectToShift(null);
									}}
									handleSelection={handleSelectToShift}
									hideAddNew
									placeholder='Select shift'
									selectedValue={selectedShift?.name}
									classname={styles['vendor-selector']}
								/>
								{selectedShift && (
									<div className={styles.shiftStartEnd}>
										{selectedShift?.process?.[0]?.startTime}{' '}
										- {selectedShift?.process?.[0]?.endTime}
									</div>
								)}
							</div>
						</div>
					</div>
				)}
			{orderType === 6 && (
				<div className={classes(styles['label-container'])}>
					<label
						className='flex gap-2 items-center'
						htmlFor='workerGrad'
					>
						Workers
					</label>
					<div
						style={{ width: '300px' }}
						className='flex items-center gap-2'
					>
						{state?.workersGrade?.map((ele, index) => {
							return (
								<div
									className='flex items-center gap-2'
									key={index}
								>
									<span className='text-nowrap'>
										{ele?.label}
									</span>
									<input
										className='w-20 border border-gray-300 rounded p-1'
										type='number'
										value={ele?.value}
										onChange={(e) => {
											handleWorkersGradeChange(
												{ ...ele, index },
												e.target.value
											);
										}}
										onKeyDown={(e) => {
											if (
												[
													'-',
													'+',
													'e',
													'E',
													'.',
												].includes(e.key)
											) {
												e.preventDefault();
											}
										}}
									/>
								</div>
							);
						})}
					</div>
				</div>
			)}
			<div className={styles.multi}>
				{isEdit && (
					<div className={classes(styles['label-container'])}>
						<label
							className={styles.mandatory}
							htmlFor='purchaseOrder'
						>
							{orderType === 8
								? 'Sales Order ID*'
								: 'Purchase Order ID*'}
						</label>
						<IconInput
							type='custom'
							iconText={
								orderType === 8
									? 'So-'
									: `${purchaseOrderId?.split('-')?.[0]}`
							}
							size='extra-large'
							inputType='text'
							isDisabled
							value={purchaseOrderId?.split('-')?.[1]}
							// handleInput={handleNumericInput}
							style={{
								width: '300px',
							}}
						/>
					</div>
				)}
			</div>
			{orderType === 8 && (
				<div className={styles.multi}>
					{requiredFields?.poId && (
						<div className={classes(styles['label-container'])}>
							<label
								className={styles.mandatory}
								htmlFor='purchaseOrder'
							>
								Order Ref No
							</label>
							<Input
								type='text'
								value={externalOrderRef}
								onChange={handleOrderRefInput}
								style={{
									width: '300px',
								}}
							/>
						</div>
					)}
				</div>
			)}
			{requiredFields?.date && (
				<div className={classes(styles['label-container'])}>
					<label className={styles.mandatory} htmlFor='dateSelector'>
						Order Date*
					</label>
					<span className='text-nowrap'>
						{moment(state?.date)?.format('DD/MM/YYYY')}
					</span>
					{/* <DatePickerCustom
						selectedDate={date}
						selectDate={(poDate) => {
							setState('SET_DATE', poDate);
							setState('SET_EXPECTED_DELIVERY_DATE', null);
						}}
						style={{
							width: 200,
						}}
						oneTap
						defaultValue={date}
						shouldDisableDate={disabledDate}
					/> */}
				</div>
			)}
			{requiredFields?.expectedDeliveryDate && (
				<div className={classes(styles['label-container'])}>
					<label className={styles.mandatory} htmlFor='deliveryDate'>
						{type === 'SERVICE'
							? 'Expected service date'
							: 'Expected Delivery Date*'}
					</label>
					<div className='block'>
						{dispatchDelta && formattedDate && (
							<p className='text-blue-700 m-1'>
								Dispatch Date:
								{formattedDate}
							</p>
						)}
						<DatePickerCustom
							selectedDate={expectedDeliveryDate}
							selectDate={(deliveryDate) => {
								setState(
									'SET_EXPECTED_DELIVERY_DATE',
									deliveryDate
								);
							}}
							style={{
								width: 300,
							}}
							oneTap
							defaultValue={expectedDeliveryDate}
							shouldDisableDate={disabledExpiryDate}
							disabled={disableAll}
						/>
					</div>
				</div>
			)}
			{requiredFields?.inventoryAtDayEndOf && (
				<div className={classes(styles['label-container'])}>
					<label className={styles.mandatory} htmlFor='deliveryDate'>
						Inventory at day end of*
					</label>
					<DatePickerCustom
						selectedDate={inventoryAtDayEndOf}
						selectDate={(deliveryDate) => {
							setState('SET_INVENTORY_DATE', deliveryDate);
						}}
						style={{
							width: 200,
						}}
						oneTap
						defaultValue={inventoryAtDayEndOf}
						shouldDisableDate={(rsuiteDate) => {
							return rsuiteDate > new Date();
						}}
					/>
				</div>
			)}
			{requiredFields?.paymentTerms && (
				<div className={classes(styles['label-container'])}>
					<label className={styles.mandatory} htmlFor='paymentTerms'>
						Payment Terms*
					</label>
					<TextField
						select
						id='paymentTerms'
						value={paymentTerm}
						disabled={disbalePaymentTerm || disableAll}
						onChange={(e) => {
							setState('SET_PAYMENT_TERM', e?.target?.value);
						}}
						sx={{
							width: 300,
							'.MuiInputBase-root': {
								borderRadius: '4px',
							},
							'.MuiInputBase-input': {
								paddingTop: '6px',
								paddingBottom: '6px',
							},
						}}
					>
						{paymentTerms?.map((ele) => {
							return (
								<MenuItem key={ele} value={ele}>
									{ele}
								</MenuItem>
							);
						})}
					</TextField>
				</div>
			)}
			<div className={classes(styles['label-container'])}>
				<label
					className={styles.mandatory}
					htmlFor='priorityOrder'
					style={{ color: '#ce0014' }}
				>
					Priority order
				</label>
				<FormControlLabel
					control={
						<Switch
							color='error'
							checked={priorityOrder}
							onChange={(e) => {
								setState(
									'SET_PRIORITY_ORDER',
									e.target.checked
								);
							}}
						/>
					}
					label=''
				/>
			</div>
			<div className='flex flex-col gap-3 absolute left-[43rem]'>
				{orderType === 8 && (
					<div
						className={`flex items-center gap-4 ${
							doc?.file ? 'h-[15rem]' : 'h-auto'
						} p-2 w-[49%] bg-transparent`}
					>
						<Button
							type='button'
							variant='outline'
							color='primary'
							onClick={uploadInvoiceCick}
						>
							Refrence Document
						</Button>
						{doc?.file && doc?.fileName && (
							<div className='w-full h-full'>
								<iframe
									className='w-full h-full border rounded-md'
									src={doc?.file}
									title='PDF Rendered from Base64'
								/>
							</div>
						)}
					</div>
				)}
				{orderType !== 1 && requiredFields?.process && (
					<div className='flex flex-col gap-2'>
						{state?.deliverTo?.id &&
							mandatoryFields?.cmsIndent &&
							Array.isArray(processList) &&
							processList.length === 0 && (
								<span className='text-orange-400 text-[12px]'>
									No Process is configured at{' '}
									{state?.deliverTo?.name} for selection.
									Please add a process to this store.
								</span>
							)}
						<div className={classes(styles['label-container'])}>
							<label
								className={
									mandatoryFields?.process ||
									mandatoryFields?.cmsIndent
										? styles.mandatory
										: ''
								}
								htmlFor='process'
							>
								{filterLabels?.processTypes
									? type === 'SERVICE'
										? 'Service Location'
										: 'Delivery Location'
									: null}
								{mandatoryFields?.process ||
								mandatoryFields?.cmsIndent
									? '*'
									: ''}
							</label>
							<CustomInputSelector
								inputName='PROCESS'
								width='300px'
								disabled={
									type === 'SERVICE'
										? !processList?.length
										: !processList?.length ||
										  !state?.deliverTo?.id
								}
								inputLists={processList?.map((ele) => ({
									...ele,
									imageUrl: ele?.logo,
									name: ele?.data?.heading,
								}))}
								// eslint-disable-next-line no-unused-vars
								handleRemove={(key) => {
									handleSelectProcess(null);
								}}
								handleKeyPress={handleKeyPress}
								handleSelection={handleSelectProcess}
								hideAddNew
								placeholder={
									filterLabels?.processTypes
										? 'Select Process Type'
										: 'Select Delivery Location'
								}
								selectedValue={
									selectedProcess?.name ??
									selectedProcess?.data?.heading
								}
								classname={styles['vendor-selector']}
							/>
						</div>
					</div>
				)}
			</div>
		</div>
	);
}

export default POGeneralDetails;
